import {
  Component,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
  HostListener,
  ElementRef
} from '@angular/core';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { BuyErrors, UserService } from 'remarketing-angular-library';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ActionSubmittingComponent
} from '../../../shared/ui/comment/modal-actions/action-submitting/action-submitting.component';
import {
  ActionSubmittedComponent
} from '../../../shared/ui/comment/modal-actions/action-submitted/action-submitted.component';


@Component({
    selector: 'app-edit-delivery-modal',
    templateUrl: './edit-delivery-modal.component.html',
    styleUrls: ['./edit-delivery-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, ActionSubmittingComponent, ActionSubmittedComponent]
})
export class EditDeliveryModalComponent extends SaComponent implements OnInit {
  @ViewChild(ModalComponent) modal: ModalComponent;

  @Input() tenantName: string;
  @Input() auctionItem: any;
  @Input() modalId = 'Edit-Delivery';
  @Output() changeDelivery = new EventEmitter<boolean>();

  @ViewChild('closeButton') closeButton: ElementRef;
  @ViewChild('headerEdit') headerEdit: ElementRef;
  @ViewChild('radioYes') radioYes: ElementRef;
  @ViewChild('radioNo') radioNo: ElementRef;
  @ViewChild('submitSave') submitSave: ElementRef;
  @ViewChild('cancelSave') cancelSave: ElementRef;

  deliveryOption: boolean;
  waitingResponse = false;
  successfulResponse = false;
  errorMessage: string | ((val: string | number) => string);

  @HostListener('document:keyup.escape', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.modal.modal.isOpen) {
      this.modal.close();
    }
  }

  constructor(private userService: UserService) {
    super();
  }

  get isViewOnlyRole(): boolean {
    return this.userService.isViewOnlyRole();
  }

  ngOnInit() {}

  show(e, defaultDeliveryOption) {
    e.preventDefault();
    this.errorMessage = '';
    this.deliveryOption =
      this.auctionItem && this.auctionItem.onBidList ? this.auctionItem.localDelivery : defaultDeliveryOption;
    this.successfulResponse = false;
    this.waitingResponse = false;
    this.modal.show();
  }

  setDeliveryValue(value: boolean) {
    this.deliveryOption = value;
  }

  changeDeliveryOption() {
    this.waitingResponse = true;
    this.changeDelivery.emit(this.deliveryOption);
  }

  setSuccessfulResponse() {
    this.waitingResponse = false;
    this.successfulResponse = true;
  }

  setErrorResponse(errorText = BuyErrors.MSG_BUY_002) {
    this.errorMessage = errorText;
    this.waitingResponse = false;
    this.successfulResponse = false;
  }

  cancel() {
    this.modal.close();
  }

  focusToElem(elem: string) {
    switch (elem) {
      case 'header': {
        this.headerEdit.nativeElement.focus();
        break;
      }
      case 'close': {
        this.closeButton.nativeElement.focus();
        break;
      }
      case 'radioYes': {
        this.radioYes.nativeElement.focus();
        break;
      }
      case 'radioNo': {
        this.radioNo.nativeElement.focus();
        break;
      }
      case 'cancel': {
        this.cancelSave.nativeElement.focus();
        break;
      }
      case 'submit': {
        this.submitSave.nativeElement.focus();
        break;
      }
    }
  }
}
